import api from 'service/api'

// Sem tratamento de erro: uma falha aqui não deve redirecionar a tela. O
// provider cai para o catálogo local e o app segue funcionando.
const dponetAPI = api.create('dponet', false)

const get = async () => await dponetAPI.get('/external_services')

export default {
  get,
}
